import { getEnv } from '../environment';
import KeycloakAuthService from './KeycloakAuthService';
import MockAuthService from './MockAuthService';

const useMockService =
  (getEnv('NODE_ENV') === 'jest' || getEnv('NODE_ENV') === 'development') && !getEnv('VUE_APP_USE_DEV_PROXY');

const authService = useMockService ? MockAuthService : KeycloakAuthService;

export default authService;
